import React, { useState, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import { getTemplates } from "../../../../../../api";
import Skeleton from "../../../../../../components/Skeleton";
import "../../OperationResults/styles.scss";

const ALL = "all";
const CUSTOM = "custom";

const CriteriaList = ({
  areaCriteria,
  documentCriteria,
  selectedCriteria,
  setSelectedCriteria,
  selectedTemplate,
  setSelectedTemplate,
  loading
}) => {
  const { formatMessage } = useIntl();
  const [availableCriteria, setAvailableCriteria] = useState([]);
  const [templates, setTemplates] = useState([]);
  // const [selectedTemplate, setSelectedTemplate] = useState(ALL);

  useEffect(() => {
    getTemplates().then(res => {
      const templates = res.data?.result?.data;

      setTemplates(templates);
    });
  }, []);

  useEffect(() => {
    const newCriteria = [
      ...(!!areaCriteria?.length
        ? areaCriteria.map(criterion => criterion.B3Criterio)
        : []),
      ...(!!documentCriteria?.length
        ? documentCriteria.map(criterion => criterion.B3Criterio)
        : [])
    ];

    setAvailableCriteria(newCriteria);
    setSelectedTemplate(ALL);
    setSelectedCriteria(newCriteria.map(crit => crit.id));
  }, [
    areaCriteria,
    documentCriteria,
    setSelectedCriteria,
    setSelectedTemplate
  ]);

  const handleTemplateChange = useCallback(
    e => {
      if (e.target.value === ALL) {
        setSelectedTemplate(ALL);
        setSelectedCriteria(availableCriteria.map(crit => crit.id));
      } else {
        const newTemplate = templates.find(
          template => template.B3Template.id === e.target.value
        );
        setSelectedTemplate(e.target.value);
        setSelectedCriteria(newTemplate.B3Criterio.map(({ id }) => id));
      }
    },
    [availableCriteria, setSelectedCriteria, templates, setSelectedTemplate]
  );

  const handleCriterionToggle = useCallback(
    e => {
      if (
        e.target.checked &&
        selectedCriteria.length === availableCriteria.length - 1
      ) {
        setSelectedTemplate(ALL);
      } else {
        setSelectedTemplate(CUSTOM);
      }

      if (e.target.checked) {
        setSelectedCriteria([...selectedCriteria, e.target.value]);
      } else {
        const removeIndex = selectedCriteria.indexOf(e.target.value);
        setSelectedCriteria([
          ...selectedCriteria.slice(0, removeIndex),
          ...selectedCriteria.slice(removeIndex + 1, selectedCriteria.length)
        ]);
      }
    },
    [
      selectedCriteria,
      setSelectedCriteria,
      availableCriteria,
      setSelectedTemplate
    ]
  );

  return (
    <div className="criteria-list">
      <select
        value={selectedTemplate}
        onChange={handleTemplateChange}
        disabled={!loading}
        className="template-selector"
      >
        <option value={ALL}>{formatMessage({ id: "todos" })}</option>
        <option value={CUSTOM} disabled>
          {formatMessage({ id: "personalizado" })}
        </option>
        {templates.map(({ B3Template: template }) => (
          <option value={template.id} key={template.id}>
            {template.nome}
          </option>
        ))}
      </select>

      {!loading &&
        Array.from(new Array(4)).map((_, index) => (
          <Skeleton key={index} width="calc(100% - 24px)" ml={12} />
        ))}

      <div className="checkbox-list">
        {availableCriteria.map(option => (
          <div key={option.id} className="criteria-line">
            <input
              data-testid={`criteria-${option.id}`}
              type="checkbox"
              name="selectedCriteria[]"
              value={option.id}
              checked={selectedCriteria.includes(option.id)}
              onChange={handleCriterionToggle}
            />
            <div className="left">{option.nome}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CriteriaList;
